var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb600",
    d: "M17.208 12.343L12.23 7.365l4.978-4.978zm-14.914.734L7.3 8.072l1.754 1.739c.203.201.53.2.733-.002l1.71-1.71 4.977 4.978zm-.734-.734v-9.96L6.562 7.34zm14.913-10.69L9.417 8.709 2.299 1.653zm.215-1.039H2.08c-.858 0-1.558.7-1.558 1.558v10.386a1.56 1.56 0 0 0 1.558 1.558h14.61a1.56 1.56 0 0 0 1.557-1.558V2.172A1.56 1.56 0 0 0 16.688.614z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.a23d35ca1b92903e41782b0615a36c1d.svg";
export { ForwardRef as ReactComponent };